var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pupilRef",staticClass:"pupil",style:({
  width: _vm.size + 'px', height: _vm.size + 'px',
  backgroundColor: _vm.pupilColor,
  transform: `translate(${_vm.pos.x}px, ${_vm.pos.y}px)`,
})})
}
var staticRenderFns = []

export { render, staticRenderFns }